import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiWalletCardList } from '@api/_api/api-payment/api-payment.model';
import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ApiWalletService {
    constructor(private readonly http: HttpClient, private readonly requestService: HttpRequestsService) {}

    public getWalletCards(storeId: string, languageId: string): Observable<ApiWalletCardList> {
        const slug = `wallet/store/${storeId}/cards`;
        const url = this.requestService.requestUrl(slug, languageId);
        return this.http.get<ApiWalletCardList>(url, { withCredentials: true });
    }
}
